import React, {useEffect, useState} from 'react';
import {
    FORM_CONSTRAINTS,
    PAGE_REGISTRATION_FAILED,
    PAGE_REGISTRATION_THANK_YOU,
    PAGE_SHOP,
    PAGE_SHOP_FAILED
} from '../constants';
import {isDesktop} from '../utils';
import {useNavigate} from "react-router-dom";
import {connect} from "react-redux";

import {
    email,
    emailStatus,
    error,
    getAgentId,
    getBirthdateStatus,
    getBirthDay,
    getBirthMonth,
    getBirthYear,
    getCountry, getDeleteDormantClientEnabled,
    getErrorMessage,
    getFirstName,
    getFirstNameError,
    getFirstNameStatus,
    getFullPromocode,
    getIsFormValidating,
    getMailFrom,
    getMigrationParam, getMobile, getMobileErrorCode,
    getOtpValid,
    getPassword, getPasswordConfirm, getPasswordConfirmStatus,
    getPasswordError,
    getPasswordStatus,
    getPromocode,
    getPromocodeStatus,
    getreactivationCode,
    getreactivationStatus,
    getSurname,
    getSurnameError,
    getSurnameStatus, getTermsStatus,
    getUsername,
    getUsernameStatus,
    getValidationMessage,
    isFinish,
    isModalOpen,
    links,
    mobileMessage,
} from '../selectors';

import {changeFirstname, changePassword, changePasswordConfirmAction, changeSurname, sendRecoveryPasswordAction,
    setErrorMessageAction, setModalOpenAction, submitClientFromShop, validateForm} from '../reducers';
import Promocode from "./formItems/Promocode";
import State from "./formItems/State";
import MobilePhone from "./formItems/MobilePhone";
import Email from "./formItems/Email";
import Username from "./formItems/Username";
import Password from "./formItems/Password";
import ConfirmPassword from "./formItems/ConfirmPassword";
import Name from "./formItems/Name";
import Surname from "./formItems/Surname";
import BirthDate from "./formItems/BirthDate";
import TermsAndConditions from "./formItems/TermsAndConditions";
import ModalResetPassword from "./formItems/ModalResetPassword";
import ModalDeleteDormantUser from "./formItems/ModalDeleteDormantUser";

const useComponentDidMount = onMountHandler => {
    React.useEffect(() => {
        onMountHandler();
    }, []);
};

const stateToProps = state => ({
    email: email(state),
    emailStatus: emailStatus(state),
    mobile: getMobile(state),
    mobileMessage: mobileMessage(state),
    mobileErrorCode: getMobileErrorCode(state),
    isFinish: isFinish(state),
    error: error(state),
    errorMessage: getErrorMessage(state),
    validationMessage: getValidationMessage(state),
    promocode: getPromocode(state),
    fullPromocode: getFullPromocode(state),
    migrationParam: getMigrationParam(state),
    promocodeStatus: getPromocodeStatus(state),
    links: links(state),
    username: getUsername(state),
    usernameStatus: getUsernameStatus(state),
    password: getPassword(state),
    passwordStatus: getPasswordStatus(state),
    passwordConfirm: getPasswordConfirm(state),
    passwordConfirmStatus: getPasswordConfirmStatus(state),
    passwordError: getPasswordError(state),
    firstname: getFirstName(state),
    firstnameStatus: getFirstNameStatus(state),
    firstnameError: getFirstNameError(state),
    surname: getSurname(state),
    surnameStatus: getSurnameStatus(state),
    surnameError: getSurnameError(state),
    day: getBirthDay(state),
    month: getBirthMonth(state),
    year: getBirthYear(state),
    dateStatus: getBirthdateStatus(state),
    mailFrom: getMailFrom(state),
    reactivationStatus: getreactivationStatus(state),
    reactivationCode: getreactivationCode(state),
    country: getCountry(state),
    otpValid: getOtpValid(state),
    agentId: getAgentId(state),
    isFormValidating: getIsFormValidating(state),
    termsStatus: getTermsStatus(state),
    isModalOpen: isModalOpen(state),
    deleteDormantClientEnabled: getDeleteDormantClientEnabled(state),
});

const actionsToProps = dispatch => ({
    submitClientFromShop: payload => dispatch(submitClientFromShop(payload)),
    changePassword: payload => dispatch(changePassword(payload)),
    changeFirstname: payload => dispatch(changeFirstname(payload)),
    changeSurname: payload => dispatch(changeSurname(payload)),
    validateForm: payload => dispatch(validateForm(payload)),
    setModalOpen: payload => dispatch(setModalOpenAction(payload)),
    sendRecoveryPassword: payload => dispatch(sendRecoveryPasswordAction(payload)),
    setErrorMessage: payload => dispatch(setErrorMessageAction(payload)),
    changePasswordConfirm: payload => dispatch(changePasswordConfirmAction(payload)),
});

const Form = props => {
    const [pathname, setPathname] = useState(location.pathname.toLowerCase());

    const navigate = useNavigate();
    useEffect(() => {
        if (props.emailStatus !== "error") {
            if (props.isFinish === "success") {
                navigate(PAGE_REGISTRATION_THANK_YOU);
            } else if (props.isFinish === "error") {
                if (pathname.startsWith(PAGE_SHOP)) {
                    navigate(PAGE_SHOP_FAILED);
                } else {
                    navigate(PAGE_REGISTRATION_FAILED);
                }
            }
        }

        // Only for shop agent registration
        if (props.otpValid === false) {
            navigate(PAGE_SHOP_FAILED);
        }
    }, [props.isFinish, pathname, props.otpValid]);

    useComponentDidMount(() => {
        if (pathname.startsWith(PAGE_SHOP)) {
            if (props.agentId == null) {
                props.setErrorMessage(
                    { error: { message: 'Agent token is not valid.', code: -19731 } }
                );
                navigate(PAGE_SHOP_FAILED);
            }
        }
    });

    const onSubmit = () => {
        const body = {
            username: props.username,
            password: props.password,
            firstname: props.firstname,
            lastname: props.surname,
            device: isDesktop() === true ? 'Desktop' : 'Mobile',
            source: 'Shop',
            day: props.day,
            month: props.month,
            year: props.year,
            mobile: props.mobile,
            state: props.country,
            agent: props.agentId,
            migrationParam: props.migrationParam,
            queryParam: 'v=2&IDLingua=2',
            email: props.email
        }

        if (!pathname.startsWith(PAGE_SHOP)) {
          body.agent = props.promocode;
          body.promotion = props.fullPromocode;
        }

        props.submitClientFromShop({body});
    };

    const isFormValid = () => {
        return (pathname.startsWith(PAGE_SHOP) || props.promocodeStatus === 'success') &&
            (props.email === '' || (props.email !== '' && props.emailStatus !== 'error')) &&
            // props.usernameStatus === 'success' &&
            props.passwordStatus === 'success' &&
            props.passwordConfirmStatus === 'success' &&
            props.firstnameStatus === 'success' &&
            props.surnameStatus === 'success' &&
            props.dateStatus === 'success' &&
            props.mobileMessage === 'success' &&
            props.country !== '' &&
            props.termsStatus === 'success';
    };

    const checkPassword = () => {
        let passwordValid = true;
        if (props.password === '') {
            props.changePassword({passwordStatus: 'none'});
        } else {
            const date = new Date(2000,1,1);
            date.setMonth(props.month - 1);
            const monthLabel = date.toLocaleString('en-US', { month: 'long' });

            const day = props.day < 10 ? `0${props.day}` : props.day;
            const month = props.month < 10 ? `0${props.month}` : props.month;

            const passwordRegex = new RegExp(String.raw`^(?=\S*?[a-zA-Z])(?=\S*?[0-9])\S{${FORM_CONSTRAINTS.password.min_length},${FORM_CONSTRAINTS.password.max_length}}$`);
            const isPasswordRegexValidated = passwordRegex.test(props.password);

            passwordValid = isPasswordRegexValidated &&
                (props.username === '' ||
                    props.password.toLowerCase().indexOf(props.username.toLowerCase()) === -1) &&
                (props.firstname === '' ||
                    props.password.toLowerCase().indexOf(props.firstname.toLowerCase()) === -1) &&
                (props.surname === '' ||
                    props.password.toLowerCase().indexOf(props.surname.toLowerCase()) === -1) &&
                props.password.indexOf(`${day}${month}${props.year}`) === -1 &&
                props.password.indexOf(`${props.year}${month}${day}`) === -1 &&
                props.password.toLowerCase().indexOf(`${day}${monthLabel.toLowerCase()}${props.year}`) === -1 &&
                props.password.toLowerCase().indexOf(`${props.year}${monthLabel.toLowerCase()}${day}`) === -1;

            props.changePassword({ passwordStatus: passwordValid === true ? 'success' : 'error' });
        }

        checkRepeatedPassword();

        return passwordValid;
    };

    const checkPasswordAndValidateForm = (fieldName) => {
        const passwordValid = checkPassword();
        if (passwordValid) {
            if (fieldName !== 'password' || (fieldName === 'password' && props.password !== '')) {
                props.validateForm({updatedField: fieldName});
            }
        }
    };

    const checkRepeatedPassword = () => {
        if (props.password === '' || props.passwordConfirm === '') {
            props.changePasswordConfirm({passwordConfirmStatus: 'none'});
        } else {
            props.changePasswordConfirm({
                passwordConfirmStatus: props.password === props.passwordConfirm ? 'success' : 'error'
            });
        }
    };

    const checkFirstname = () => {
        if (props.firstname === '') {
            props.changeFirstname({ firstnameStatus: 'none' });
        } else {
            const firstNameRegex = new RegExp(String.raw`^[A-Za-z][A-Za-z '-]{${FORM_CONSTRAINTS.first_name.min_length - 1},${FORM_CONSTRAINTS.first_name.max_length}}$`);
            const isFirstNameRegexValidated = firstNameRegex.test(props.firstname);

            props.changeFirstname({
                firstnameStatus: isFirstNameRegexValidated ? 'success' : 'error',
            });

            if (isFirstNameRegexValidated) {
                checkSurname('firstname');
            }
        }
    };

    const checkSurname = (fieldName) => {
        const updatedField = fieldName || 'surname';

        if (props.surname === '') {
            props.changeSurname({ surnameStatus: 'none' });
        } else {
            const surnameRegex = new RegExp(String.raw`^[A-Za-z][A-Za-z '-]{${FORM_CONSTRAINTS.surname.min_length - 1},${FORM_CONSTRAINTS.surname.max_length}}$`);
            const isSurnameFEValidated = surnameRegex.test(props.surname)  && props.firstname !== props.surname;

            props.changeSurname({
                surnameStatus: isSurnameFEValidated ? 'success' : 'error',
            });

            if (updatedField === 'surname' && isSurnameFEValidated) {
                props.validateForm({updatedField: updatedField});
            }
        }

        if (props.password !== '') {
            checkPasswordAndValidateForm(updatedField);
        } else if (updatedField === 'firstname' && props.firstname !== '') {
            props.validateForm({updatedField: updatedField});
        }
    };

    const showModal = () => {
        if (pathname.startsWith(PAGE_SHOP) && props.isModalOpen) {
            if (props.mobileErrorCode === -21732) {
                // User already registered under same agent
                return <ModalResetPassword />
            } else if (props.deleteDormantClientEnabled) {
                // User already registered under same agent and not logged for long time (can be deleted)
                return <ModalDeleteDormantUser />
            }
        }
    }

    return (
        <React.Fragment>
            <form className="reg-form table-cell">
                <p className="intro--txt pl10 pr20">
                    Please fill in the details below to complete your account activation.
                </p>
                <p className="intro--txt mr10 pl10 underline">
                    <span className="asterisk">*</span> Fields must be completed
                </p>

                <div className="reg-container wrap">
                    {!pathname.startsWith(PAGE_SHOP) &&
                        <Promocode />
                    }

                    <div className="separator" />

                    <State />

                    <MobilePhone pathname={pathname} />

                    <Email />

                    <div className="separator" />

                    <Username checkPasswordAndValidateForm={checkPasswordAndValidateForm} />

                    <Password checkPasswordAndValidateForm={checkPasswordAndValidateForm} />

                    <ConfirmPassword checkRepeatedPassword={checkRepeatedPassword} />

                    <div className="separator" />

                    <Name checkFirstname={checkFirstname}/>

                    <Surname checkSurname={checkSurname} />

                    <BirthDate />

                    <div className="separator" />

                    <TermsAndConditions />

                    <div className="separator" />

                    {props.isFinish !== 'success' ?
                        <p className="intro--txt registration-error-txt pl10 pr20 mb10">
                            {props.validationMessage ? props.validationMessage : props.error.message}
                        </p> : null
                    }

                    {props.isFinish === 'pending' ?
                        <div className="loader pull-right" />
                        :
                        <a id="proceed" onClick={onSubmit} className="btn btn-register pull-right" title="Finish & Login"
                            disabled={!isFormValid() || props.isFinish === 'success' || props.reactivationStatus === 'success'}>
                            Finish & Login
                        </a>
                    }
                </div>
            </form>

            {showModal()}
        </React.Fragment>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Form);
